<template>
    <div>
        <fluke-card>
            <header>
                <div class="title">Editar Senha</div>
                <div class="description">Insira a nova senha</div>
            </header>
            <main>
                <div class="notes" v-if="reseting">
                    A sua senha foi editada por um outro usuário.<br>
                    Por favor, altere a sua senha.
                </div>
                <v-text-field
                    label="Senha"
                    :type="'password'"
                    v-model="password" />
                <v-text-field
                    label="Confirmar Senha"
                    :type="'password'"
                    v-model="password_confirm" />
                <div class="pass_confirm" v-if="password != password_confirm">* A confirmação está diferente da senha.</div>
            </main>
            <footer>
                <fluke-button v-on:click.native="cancel" color="grey">cancelar</fluke-button>
                <fluke-button v-on:click.native="submit">Salvar</fluke-button>
            </footer>
        </fluke-card>
    </div>
</template>

<script>
import axios from 'axios';

import Card from '../../components/Main/Content/Card/Card.vue';
import Button from '../../components/Main/Content/Button/Button.vue';


export default {
    components: {
        'fluke-card': Card,
        'fluke-button': Button
    },
    data: function() {
        return {
            id: '',
            password: '',
            password_confirm: '',
            reseting: false
        }
    },
    created() {
        this.id = this.$route.params.id;
        if( this.$route.params.reset == true )
        {
            this.reseting = true;
        }
    },
    methods: {
        submit: async function()
        {
            if( this.password != this.password_confirm )
            {
                this.$store.commit(
                    'flash_error',
                    'A confirmção está  diferente da senha.'
                );
                return;
            }
            const result = await axios.put(
				this.$myServerAddresses.admin + 'users/pass',
				{
                    password: this.password,
                    id: this.$route.params.id,
                    reset: this.$cookies.get('userId') == this.$route.params.id ? 0 : 1
				},
                {
                    headers: {
                        'X-Fluke': this.$cookies.get('token')
                    }
                }
            );
            if( result.data.success )
            {
                this.$store.commit(
                    'flash_success',
                    'Senha alterada com sucesso!'
                );
            }
            this.$router.push({ name: 'users-edit', params: { id: this.id } });
        },
        cancel: function() {
            this.$router.push({ name: 'users-edit', params: { id: this.id } });
        },
    }
}
</script>

<style lang="scss">
.pass_confirm {
    color: #cc7676;
}
</style>
